<script setup>
    import { ref } from "vue";
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    import TableAdvanced from "@/Components/TableAdvanced.vue";
    import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

    defineProps({
        students: Array,
        columnas: Array,
        classrooms: Object,
        teoricclassrooms: Object,
        isAdmin: Boolean,
        isCoord: Boolean,
        userParam: Object
    });

    const rutaPrefijo = ref('student');
    const modulo = ref('estudiante');
    const modulos = ref('Estudiantes');
</script>

<template>
    <Head title="Estudiantes" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <div class="flex justify-between items-center">
                <div>
                    <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                        Estudiantes <!-- In basebutton: @click="route('dashboard')"-->               
                    </h2> 
                </div>
                <div>
                    <Link :href="route(rutaPrefijo+'-create')">
                        <BaseButton
                            color="info"
                            :icon="mdiPlusCircle"
                            small
                            label=" Nuevo"
                            class="inline-flex"
                        />
                    </Link>
                </div>
            </div>
        </template>

        <div class="py-12">
            <div class="mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        
                        <CardBox v-if="students.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto relative">
                                <TableAdvanced :modulo="modulo" :modulos="modulos" :userParam="userParam" :data="students" :fields="columnas" :ruta="rutaPrefijo" exporteable visualable checkable :changeOption1="(isAdmin ? true : false)" searchAdvance
                                    changeSelect1 titleSelect1="aula de estudio" :select1="classrooms"
                                    changeSelect2 titleSelect2="aula matrícula" :select2="classrooms"
                                    changeSelect3 titleSelect3="aula ugel" :select3="teoricclassrooms"
                                    changeSelect4 titleSelect4="aula estudio y matrícula" :select4="classrooms"
                                    optionsbutton
                                />
                            </div>
                           
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
